import { ButtonChipItem, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { DATA_AUTOMATION_FILTER_WRAPPER } from "./dataAutomationKeys";
import { StyledFilterWrapper } from "./styles";
import type { FiltersSchema } from "./types";

export const Filters = ({ items, selectedId, isDisabled, flags, onClick, disabledToolTip }: FiltersSchema) => (
    <>
        {items.map(({ id, text }) => {
            const isSelected = id === selectedId && !isDisabled;
            const isFilterDisabled = isDisabled || flags[id];

            const handleOnClick = () => {
                if (!isFilterDisabled) {
                    onClick(id);
                }
            };

            const isTooltipEnabled = flags[id] && !!disabledToolTip;

            return (
                <StyledFilterWrapper
                    key={id}
                    isDisabled={isFilterDisabled}
                    data-automation={DATA_AUTOMATION_FILTER_WRAPPER(id)}
                >
                    <Tooltip
                        placement="top"
                        enabled={isTooltipEnabled}
                        content={disabledToolTip}
                    >
                        <span>
                            <ButtonChipItem
                                theme="light"
                                isSelected={isSelected}
                                onClick={handleOnClick}
                                hideActionButton
                                text={translate(text)}
                                className="filterChip"
                            />
                        </span>
                    </Tooltip>
                </StyledFilterWrapper>
            );
        })}
    </>
);
